import React from "react";
export default function BoardHeader({ visibleRoleKeys = [], roleOptions, isTablet = false }) {
  return <div style={{display:'grid', gridTemplateColumns:`84px repeat(${visibleRoleKeys.length}, minmax(${isTablet ? 146 : 156}px, 1fr))`, gap:7, marginBottom:7, position:'sticky', top:0, zIndex:20, background:'#fff'}}>
    <div className="schedule-role-header">Time</div>
    {visibleRoleKeys.map(rk => <div className="schedule-role-header" key={rk}>{String(roleOptions?.map?.get(rk) || rk).replace(/_/g,' ')}</div>)}
  </div>;
}
